import { render, staticRenderFns } from "./management_record_detail.vue?vue&type=template&id=71c0b710&scoped=true&"
import script from "./management_record_detail.vue?vue&type=script&lang=js&"
export * from "./management_record_detail.vue?vue&type=script&lang=js&"
import style0 from "./management_record_detail.vue?vue&type=style&index=0&id=71c0b710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0b710",
  null
  
)

export default component.exports